import React from 'react';
import axios from 'axios';
import { Loading, ToastNotification } from 'carbon-components-react';
import { t } from '../../RI18n';
import './style.css';

class VmManagersStatus extends React.Component {
  static hasNoVmManagers(response) {
    let missingVmManager = false;
    let outdatedVmManager = false;
    if (response.items !== undefined) {
      response.items.forEach((el) => {
        if (el.status === 'client_health_status_missing_vm_manager') {
          if (el.quantity > 0) {
            missingVmManager = true;
          }
        }
        if (el.status === 'client_health_status_outdated_vm_manager') {
          if (el.quantity > 0) {
            outdatedVmManager = true;
          }
        }
      });
      return missingVmManager || outdatedVmManager;
    }
    return false;
  }

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      vmManagersStatus: {},
    };
  }

  componentDidMount() {
    const url = '/sam/todo_list/vm_managers_status.json';
    axios
      .get(url)
      .then((result) => {
        this.setState({
          isLoaded: true,
          vmManagersStatus: result.data,
        });
      })
      .catch(() => {
        this.setState({
          isLoaded: true,
          error: false,
        });
      });
  }

  render() {
    const { error, isLoaded, vmManagersStatus } = this.state;

    if (vmManagersStatus.to_display === false) {
      return null;
    }

    if (error) {
      console.log(t('todolist.no_vm_managers.error'));
      return null;
    } if (!isLoaded) {
      return (
        <span>
          <br />
          <Loading small withOverlay={false} />
        </span>
      );
    }
    if (VmManagersStatus.hasNoVmManagers(vmManagersStatus)) {
      if (this.props.notify) {
        this.props.updateToDos();
      }

      const renderedReportStatusText = t('widget.status.warning');

      const titleText = t('todolist.no_vm_managers.title');

      const titleTextWithTooltip = <span className="notification_text" title={renderedReportStatusText}>{titleText}</span>;

      const subtitleText = (
        <div
          className="notification_text"
          dangerouslySetInnerHTML={{
            __html: t('todolist.no_vm_managers.subtitle'),
          }}
        />
      );

      const captionText = (
        <span className="notification_text">
          <span
            dangerouslySetInnerHTML={{
              __html:
                  vmManagersStatus.is_lmt === true
                    ? t('todolist.no_vm_managers.caption_1_lmt')
                    : t('todolist.no_vm_managers.caption_1_bfi'),
            }}
          />
          <br />
          <br />
          <span
            dangerouslySetInnerHTML={{
              __html: t('todolist.no_vm_managers.caption_2'),
            }}
          />
          <br />
          <br />
          <span
            dangerouslySetInnerHTML={{
              __html:
                  vmManagersStatus.is_lmt === true
                    ? t('todolist.no_vm_managers.caption_3_lmt')
                    : t('todolist.no_vm_managers.caption_3_bfi'),
            }}
          />
        </span>
      );

      return (
        <ToastNotification
          className="notification_style"
          title={titleTextWithTooltip}
          subtitle={subtitleText}
          caption={captionText}
          hideCloseButton
          kind="warning"
          aria-label={t('todolist.aria_label', { name: t('todolist.no_vm_managers.name'), status: renderedReportStatusText })}
          role="region"
        />
      );
    }
    return null;
  }
}

export default VmManagersStatus;
